// Canlı Destek (süper admin) paneli kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.liveSupport';

export const superAdminLiveSupportGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Canlı Destek nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Ziyaretçilerin açtığı canlı destek taleplerini görür, devralır ve yanıtlarsınız. Süper Admin Paneli açıkken sağ alt köşedeki düğmelerden kullanılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Canlı Destek Talepleri'),
    body: t(`${G}.regions.body`, 'Adınız ve talep listesi'),
    footer: t(`${G}.regions.footer`, 'Yenile'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Yeni talepleri fark edin'),
      text: t(`${G}.s1.text`, 'Sağ alttaki destek düğmesi bekleyen talep sayısını gösterir. Yeni talep gelince sesli uyarı çalar, düğme kırmızıya döner ve bu pencere kendiliğinden açılır. Bekleyen talep kalmayınca ses durur.'),
      tips: [
        t(`${G}.s1.tip1`, 'Uyarıyı sayfası açık olan tüm yetkililer duyar; görüşmeyi ilk devralan üstlenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Adınızı yazıp talebi devralın'),
      text: t(`${G}.s2.text`, '"Adınız (ziyaretçiye görünecek)" alanı ad soyadınızla dolu gelir; isterseniz değiştirin. Bekleyen talepte "Devral" deyin; görüşme penceresi açılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Ad alanı boşsa devralamazsınız.'),
        t(`${G}.s2.tip2`, 'Talebi sizden önce başka biri devraldıysa "Bu görüşmeyi ... devraldı" uyarısı çıkar; satırda devralanın adı görünür.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Yanıt verin, görüşmeyi kapatın'),
      text: t(`${G}.s3.text`, 'Mesajınızı yazıp Enter\'a basın (alt satır için Shift+Enter) ya da gönder düğmesine tıklayın. İş bitince "Görüşmeyi Kapat" deyin. Ziyaretçi görüşmeyi sonlandırırsa pencere açık kalır ama yazma alanı kilitlenir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Pencereyi kapatsanız da görüşme sürer: "... aktif görüşmeniz var" etiketine ya da listedeki "Görüşmeye Dön" düğmesine tıklayarak geri dönün.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Görüşmeleri izleyin'),
      text: t(`${G}.s4.text`, 'Destek düğmesinin üstündeki göz düğmesi "Aktif Görüşmeler (İzleme)" listesini açar. "İzle" ile herhangi bir görüşmenin mesajlarını canlı okursunuz; izleme salt okunurdur, mesaj gönderilemez. "Yenile" listeyi tazeler.'),
    },
  ],
});
